<div class="auth">
  <div class="auth-container mat-elevation-z1">
    <h1>Registry Admin</h1>
    <button mat-raised-button class="auth-button" color="primary" (click)="authenticateWithGoogle()">
      Sign in with Google<mat-icon>login</mat-icon>
    </button>
  </div>
</div>
